// extracted by mini-css-extract-plugin
export default {"lowerNavBar":"BottomNav_lowerNavBar__DCIoD","lowerNavBar_inner":"BottomNav_lowerNavBar_inner__516ae","active":"BottomNav_active__+qsfD"};